import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useDeleteUser({
  businessUnitCode,
  organizationCode,
}: GenericParameters) {
  const isLoading: Ref<boolean | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function deleteUser(userLogin: string): Promise<void> {
    isLoading.value = true;
    error.value = undefined;
    let response;

    if (businessUnitCode) {
      response = await userAdministrationService.deleteBusinessUnitUser({
        businessUnitCode,
        userLogin,
      });
    } else if (organizationCode) {
      response = await userAdministrationService.deleteOrganizationUser({
        organizationCode,
        userLogin,
      });
    } else {
      response = await userAdministrationService.deleteSuperAdministrationUser({
        userLogin,
      });
    }

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    deleteUser,
  };
}
